
<!--查看售后详情流程-->
<!-- subid 必传  -->
<template>
<div>
  <div class="div-b">
    <div class="div-div">
      <div class="index-card-sub">
        <p class="p1" @click="jumpToSubOrder"><span>订单详情信息</span><span class="p1_span">查看<van-icon name="arrow" /></span></p>
        <template v-if="orderDetails.dispatchType !=5">
          <p class="p2">收货人： {{orderDetails.receiveUserName}}</p>
          <p class="p2">收货人电话： {{orderDetails.receiveMobile}}</p>
          <p class="p2">收货人地址： {{orderDetails.receiveAddress}}</p>
        </template>
      
      </div>
      <div class="div-nei" v-if="imgs.length>1">
        <div v-for="(item,index) in imgs" :key="index">
          <van-image width="70" height="70" :src="item.skuImageKey" />
        </div>
      </div>
      <div class="div-nei" v-else>
        <div v-for="(item,index) in imgs" :key="index" class="div-one">
          <div class="image-view">
            <van-image width="70" height="70" :src="item.skuImageKey" />
            <div
              v-if="item.groupPeopleNum"
              class="group-buying-people-label"
              :style="{backgroundColor: item.groupBgColor, color: item.groupTextColor}"
            >{{item.groupPeopleNum}}人团</div>
          </div>
          <div class="div-info">
            <p  style="position:relative">{{item.goodsName}} 
              <br/><span class="w3" v-show="item.goodsCode">商品货号:{{item.goodsCode}}</span>
              <span class="w3" v-show="item.goodsCode && item.skuCode">规格编码:{{item.skuCode}}</span>
              <span class="w3" v-show="item.goodsCode && item.skuCode && item.internationalGoodsCode">国际编码:{{item.internationalGoodsCode}}</span>
            </p>
            <p>x{{item.goodsCount}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-show="orderDetails.adjustOrderAfterList && orderDetails.adjustOrderAfterList.length > 0">
    <div class="div-b" v-for="(tt,index) in orderDetails.adjustOrderAfterList" :key="index">
      <div class="div-div">
        <div class="index-card-sub">
          <p class="p1"><span class="btnrenf">补/退差价</span><span class="p1_span p1_spanr">{{tt.refundStatusCN}}</span></p>
        </div> 
        <div class="div-nei">
          <van-image width="70" height="70" :src="tt.skuImageUrl" />
          <div class="div-info">
            <p>{{tt.itemName}}</p>
          </div>
        </div>
        <p class="div-text">补款总额<span class="rr">￥{{tt.adjustPrice}}</span></p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { Toast } from "vant";
import Util from "@/utils/common";
export default {
  props: {
    imgs: {
      type: Array,
      default: () => {
        return [];
      },
      required: true,
    },
    role:{
      default:'user',
      type:String
    },
    orderDetails:{
      default:()=>{
        return {}
      },
      type:Object
    }
  },
  watch: {
    imgs: {
      handler: (val) => {
        if (val) {
          val.forEach((element) => {
            console.log(element);
          });
        }
      },
      deep: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    jumpToSubOrder(){
      if(this.role =='bee'){
        Util.jumpToNewPage({
          url:window.location.origin+'/h5user/beesOrderDetail?subId='+this.orderDetails.subOrderId
        })
      }else{
        Util.jumpToNewPage({
          url:window.location.origin+'/h5user/orderDetail?subId='+this.orderDetails.subOrderId
        })
      }
    }
  },
  created() {
    //console.log(this.imgs);
  },
  components: {},
};
</script>
<style lang="less" scoped rel="stylesheet/less">
.btnrenf{
      width: 140px;
      height: 60px;
      // background: #F8D541;
      border-radius: 10px;
      // border: 1PX solid #999999;
      text-align: center;
      line-height: 60px;
      color: #333333;
      font-size: 24px;
}
.div-b {
  font-size: 0.4rem;
  border-radius: 0.15rem;
  background-color: #fff;
  margin-bottom: 20px;
}
.div-div {
  max-width: 690px;
  overflow: hidden;
  overflow-x: auto;
  padding:20px 40px;
  clear: both;
  .div-nei {
    overflow-y: hidden;
    display: flex;
    .div-info {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex: 1;
      p {
        font-size: 26px;
      }
    }
    .div-one {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .image-view {
        position: relative;
      }
      .group-buying-people-label {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        height: 26px;
        font-size: 18px;
        padding: 0 8px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        line-height: 1;
      }
    }
    div {
      margin-right: 15px;
    }
  }
  .div-text{
    float: right;
    color: #999999;
    font-size: 26px;
    .rr{
      color: #ED3939;
    }
  }
  .index-card-sub{
    font-size: 26px;
    color: #333;
    padding-bottom: 20px;
    .p1{
      padding-bottom: 28px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .p1_span{
        color: #999;
        font-size: 24px;
        display: flex;
        align-items: center;
      }
      .p1_spanr{
        color: #ED3939;
      }
    }
    .p2{
      font-size: 24px;
      padding: 3px 0;
      line-height: 34px;
    }
  }
}
.w3{
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 28px;
  display: block;
}
</style>